import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

export enum DashboardItemType {
    create,
    modify,
    update,
    delete
}

export interface DashboardItemDTO {
    targetUri: string;
    message: string;
    type: DashboardItemType;
}

@Component({
    selector: 'elem-dashboard-item',
    templateUrl: './dashboard-item.component.html',
    styleUrls: ['./dashboard-item.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardItemComponent {

    @Input()
    itemDTO: DashboardItemDTO;

    constructor(private readonly router: Router) {
    }

    click(): void {
        if (this.itemDTO.targetUri) {
            if (   this.itemDTO.targetUri.startsWith('https://')
                || this.itemDTO.targetUri.startsWith('http://')
            ) {
                window.open(this.itemDTO.targetUri, '_blank', 'noopener,noreferrer');
            } else {
                this.router.navigate([this.itemDTO.targetUri]);
            }
        }
    }

}
